import { useEffect } from 'react';

import { useDownloadClientSDK } from './useDownloadClientSDK';
import { useDownloadPLC } from './useDownloadPLC';
import { useOnError } from './useOnError';
import { useRequestDesktopPacket } from './useRequestDesktopPacket';

export const useDesktopIntegration = ({
    sdk,
    enable,
    installerKey,
    installerBaseURL,
    installerVersion,
    clientURL,
    environmentID,
    license,
    identifierType,
    transactionID,
    userId,
    useTransparentPopup,
    onConnect,
    setShowOverlay,
    receivePacket
}) => {
    const downloadPLC = useDownloadPLC({ installerKey, installerBaseURL, installerVersion });
    const downloadClientSDK = useDownloadClientSDK({ clientURL });
    const requestDesktopPacket = useRequestDesktopPacket({ sdk, license, transactionID, userId, identifierType });
    const onError = useOnError({ sdk, transactionID, downloadPLC, setShowOverlay, useTransparentPopup });

    /**
     * Ensures, that proper callbacks are connected to GeoComply SDK.
     */
    useEffect(() => {
        if (!enable || !sdk) {
            return;
        }

        sdk.on('error', onError);
        sdk.on('geolocation', (geoPacket) => receivePacket(geoPacket, 'geocomply'));
        sdk.on('connect', onConnect);

        return () => {
            sdk.off('error', onError);
            sdk.off('geolocation', (geoPacket) => receivePacket(geoPacket, 'geocomply'));
            sdk.off('connect', onConnect);
        };
    }, [sdk, enable, onConnect, onError, receivePacket]);

    useEffect(() => {
        if (!enable || !sdk) {
            return;
        }

        const disconnect = () => sdk.disconnect();

        window.addEventListener('beforeunload', disconnect);
        sdk.connect(installerKey, environmentID);

        return () => {
            window.removeEventListener('beforeunload', disconnect);
            sdk.disconnect();
        };
    }, [sdk, enable, installerKey, environmentID]);

    return { requestDesktopPacket, downloadClientSDK };
};
